<template>
  <!-- 首页跳转图片页面 -->
  <div class="commonPage">
    <!-- <van-nav-bar :title="title"
                 :fixed="true"
                 left-arrow
                 @click-left="onClickLeft">
    </van-nav-bar> -->
    <div class="content">
      <div class="img_box">
        <img :src="'/img/home/' + imgName + '?timestamp=' + new Date().getTime()"
             alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    let title = this.$route.query.title || ''
    let imgName = this.$route.query.imgName || ''
    return {
      title,
      imgName
    }
  },
  methods: {
    onClickLeft () {
      this.$router.push('/home');
    }
  }
}
</script>

<style lang="less" scoped>
.commonPage {
  height: 100vh;
  background-color: #e9eaec;
  overflow: hidden;
  .van-nav-bar {
    height: 92px;
    background: #bcdfff;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #333;
      }
    }
    /deep/.van-nav-bar__title {
      color: #333;
      font-size: 36px;
      font-weight: bold;
      font-family: Source Han Sans CN;
    }
  }
  .van-hairline--bottom::after {
    border: 0;
  }
  .content {
    height: 100%;
    // height: calc(100% - 92px);
    // margin-top: 92px;
    overflow-y: auto;
    padding: 0 20px;
    .img_box {
      width: 100%;
      background: #ffffff;
      margin: 20px 0;
      border-radius: 10px;
      img {
        width: 100%;
      }
    }
  }
}
</style>> 